import { IconButton, IconButtonProps, SxProps, Theme } from "@mui/material";
import React from "react";

interface CustomIconButtonProps extends Omit<IconButtonProps, "sx"> {
  sx?: SxProps<Theme>;
}

export const CustomIconButton: React.FC<CustomIconButtonProps> = ({ children, sx, ...restProps }) => {
  const baseStyles: SxProps<Theme> = {
    backgroundColor: "secondary.main",
    borderRadius: "4px",
    color: "secondary.contrastText",
    "&:hover": {
      backgroundColor: "secondary.main",
    },
    "&:active": {
      backgroundColor: "secondary.main",
    },
  };

  const mergedStyles: SxProps<Theme> = sx ? { ...baseStyles, ...sx } : baseStyles;

  return (
    <IconButton sx={mergedStyles} disableRipple disableFocusRipple disableTouchRipple {...restProps}>
      {children}
    </IconButton>
  );
};
